<template>
    <div class="picture_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">透明度</span>
            <el-input v-model="config.opacity" @change="getRender" type="number" step="0.1" :min="0"></el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'picture_config',
        components: {},
        data() {
            return {}
        },
        computed: {
            config() {
                return this.$store.state.designer.chart.setting.params;
            },
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .picture_config {

    }
</style>
